import type { ICellRendererParams } from 'ag-grid-enterprise'
import type { ReactElement } from 'react'

import AppLogo from '~/components/AppLogo'
import useApps from '~/hooks/useApps'

import './styles.scss'

const UADashboardApplicationCellRenderer = ({ value }: ICellRendererParams<unknown, string>): ReactElement => {
  const { appsOptions } = useApps()

  const match = appsOptions.filter(({ appKey }) => appKey === value).filter(({ url }) => !!url)?.[0]

  return (
    <div className="ua-dashboard-application-cell-renderer-container">
      <AppLogo
        appLogoUrl={match?.url}
        className="ua-dashboard-application-cell-renderer-container__logo"
        size="small"
      />
      {match?.appKey ? (
        <div className="application-name-container">
          <span className="application-name">{match.appKey}</span>
        </div>
      ) : null}
    </div>
  )
}

export default UADashboardApplicationCellRenderer
